const documentsReducer = (
  state = {
    loading: false,
    data: null,
    latest: false,
    currentDocument: null,
    filters: {
      documentType: [],
      doctors: [],
      clinics: [],
      careContext: []
    }
  },
  action
) => {
  switch (action.type) {
    case "SET_DOCUMENTS_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_DOCUMENTS_DATA":
      return {
        ...state,
        data: action.payload.documentsData,
        latest: true
      };

    case "SET_DATA_TRANSFER_DATA":
      return {
        ...state,
        dataTransfers: action.payload.dataTransfersData
      };

    case "SET_CURRENT_DOCUMENT":
      return {
        ...state,
        currentDocument: action.payload.currentDocument
      };

    case "FILTER_BY_DOCUMENTS":
      return {
        ...state,
        filters: {
          ...state.filters,
          documentType: action.payload.documentsType
        }
      };

    case "FILTER_BY_CARE_CONTEXT":
      return {
        ...state,
        filters: {
          ...state.filters,
          careContext: action.payload.careContext
        }
      };

    case "FILTER_BY_DOCTORS":
      return {
        ...state,
        filters: { ...state.filters, doctors: action.payload.doctorsName }
      };

    case "FILTER_BY_CLINICS":
      return {
        ...state,
        filters: { ...state.filters, clinics: action.payload.clinicsName }
      };

    case "CLEAR_DOCUMENTS_FILTER":
      return {
        ...state,
        filters: {
          documentType: [],
          doctors: [],
          clinics: [],
          careContext: []
        }
      };

    case "FORCE_CLEAR_DOCUMENTS":
      return {
        loading: false,
        data: null,
        latest: false,
        currentDocument: null,
        filters: {
          documentType: [],
          doctors: [],
          clinics: [],
          careContext: []
        }
      };
    case "RESET":
      return {
        loading: false,
        data: null,
        latest: false,
        currentDocument: null,
        filters: {
          documentType: [],
          doctors: [],
          clinics: [],
          careContext: []
        }
      };

    default:
      return state;
  }
};
export default documentsReducer;
